export enum ArtworkStatus {
    AVAILABLE = 'Available',
    ON_HOLD = 'On Hold',
    ON_EXHIBIT = 'On Exhibit',
    SOLD = 'Sold'
}

export enum ArtworkFramed {
    FRAMED = 'Framed',
    UNFRAMED = 'Unframed'
}